<template>
    <div class="panel-body m-2">
        <vue-apex-charts
            :options="chartOptions"
            :series="series"
            width="100%"
            height="500"
            type="line"
            ></vue-apex-charts>
        <div class="row">
            <div class="col-md-4">
                <div class="card text-center border-secondary mb-3">
                    <div class="card-header text-default">
                        Delivered to
                    </div>
                    <div class="card-body text-default">
                        <h5 class="card-title text-default">{{ reportSummary.total }}</h5>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card text-center border-primary mb-3">
                    <div class="card-header">
                        Opens
                    </div>
                    <div class="card-body text-primary">
                        <h5 class="card-title">{{ percentage(reportSummary.open, reportSummary.total) }}</h5>
                        <p class="card-text">{{ reportSummary.open }}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card text-center border-success mb-3">
                    <div class="card-header">
                        Unique Opens
                    </div>
                    <div class="card-body text-success">
                        <h5 class="card-title">{{ percentage(reportSummary.unique_open, reportSummary.total) }}</h5>
                        <p class="card-text">{{ reportSummary.unique_open }}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card text-center border-warning mb-3">
                    <div class="card-header">
                        Clicks
                    </div>
                    <div class="card-body text-warning">
                        <h5 class="card-title">{{ percentage(reportSummary.click, reportSummary.total) }}</h5>
                        <p class="card-text">{{ reportSummary.click }}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card text-center border-danger mb-3">
                    <div class="card-header">
                        Unique Clicks
                    </div>
                    <div class="card-body text-danger">
                        <h5 class="card-title">{{ percentage(reportSummary.unique_click, reportSummary.total) }}</h5>
                        <p class="card-text">{{ reportSummary.unique_click }}</p>
                    </div>
                </div>
            </div>
            <div class="col-md-4">
                <div class="card text-center border-secondary mb-3">
                    <div class="card-header text-default">
                        Bounce
                    </div>
                    <div class="card-body text-default">
                        <h5 class="card-title">{{ percentage(reportSummary.bounce, reportSummary.total) }}</h5>
                        <p class="card-text">{{ reportSummary.bounce }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script charset="utf-8">
import VueApexCharts from 'vue-apexcharts';
export default {
    data() {
        const types = [
            // 'processed',
            // 'delivered',
            'open',
            'unique_open',
            'click',
            'unique_click',
            // 'deferred',
            'bounce',
            // 'dropped',
            // 'unsubscribe',
            // 'spamreport',
        ];

        return {
            types,
            selectedTypes: [
                ...types
            ],
        }
    },

    props: ['campaign', 'reports'],

    components: {
        VueApexCharts,
    },

    computed: {
        reportData() {
            return _.chain(this.reports)
                .map(item => {
                    return {
                        id: item.id, type: item.type,
                        ...(item.attributes),
                        ...(item.meta),
                    }
                })
                .value();
        },
        chartOptions() {
            let index = 0;
            let reportSummary = this.reportSummary;
            return {
                chart: {
                    id: 'message-chart',
                    toolbar: {
                        show: false
                    }
                },

                xaxis: {
                    categories: _.chain(this.reportData)
                        .map(_.property('reported_at'))
                        .map((dt) => dt.split(' ')[0])
                        .value(),
                    title: {
                        text: `Month to date`
                    }
                },
                yaxis: {
                    title: {
                        text: 'Number of Activities'
                    },
                    min: 0,
                    forceNiceScale: true,
                    decimalsInFloat: 0,
                },
                title: {
                    text: 'Activities per month by campaign',
                    align: 'left',
                },
                legend: {
                    position: 'top',
                    horizontalAlign: 'right',
                    floating: true,
                    offsetY: -10,
                    offsetX: -5,
                },
                markers: {
                    size: 5,
                },
                stroke: {
                    curve: 'straight'
                },
            }
        },

        series() {
            const fields = this.selectedTypes;

            let initial = _.chain(fields)
                .map(field => ([field, []]))
                .fromPairs()
                .value();

            return _.chain(this.reportData)
                .reduce((tmp, item) => {
                    _.map(fields, field => {
                        tmp[field] = _.concat(tmp[field], [item[field] || 0])
                    })

                    return tmp;
                }, initial)
                .toPairs()
                .map(([name, data]) => ({ name, data}))
                .value();
        },

        reportSummary() {
            let summary = _.chain(this.reports)
                .reduce((tmp, dayReport) => {
                    tmp.open += _.parseInt(_.get(dayReport, 'attributes.open') || 0);
                    tmp.unique_open += _.parseInt(_.get(dayReport, 'attributes.unique_open') || 0);
                    tmp.click += _.parseInt(_.get(dayReport, 'attributes.click') || 0);
                    tmp.unique_click += _.parseInt(_.get(dayReport, 'attributes.unique_click') || 0);
                    tmp.bounce += _.parseInt(_.get(dayReport, 'attributes.bounce') || 0);
                    tmp.total = _.parseInt(_.get(dayReport, 'attributes.total') || 0);

                    return tmp;
                }, {
                    open: 0,
                    unique_open: 0,
                    click: 0,
                    unique_click: 0,
                    bounce: 0,
                    total: 0,
                }).value();

            return summary;
        }
    },

    methods: {
        formatItemData(attributes) {
            const keys = _.keys(this.fields);
            const simplyReturn = (val) => val;

            return _.chain(attributes)
                .toPairs()
                .reduce((tmp, [key, rawValue]) => {
                    if (keys.indexOf(key) < 0) {
                        return tmp;
                    }

                    const handler = _.get(this.fields, [key, 'value'], simplyReturn);
                    return { ...tmp, [key]: handler(rawValue, attributes, this.__, this._) }
                }, {})
                .value();
        },

        percentage(value, total) {
            return String(Math.round(value * 100 / total)) + '%';
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/cms/js/components/report/CampaignReportComponent.vue